export default {
  SET_NEWS_LETTER_MAIL_TEMPLATE: function (state, payload) {
    state.newsMailTemplates = payload;
  }
}
